// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"3157f69e","925":"f4e99d57","1093":"ebe2b45a","2245":"f4e99d57","3471":"3157f69e","5109":"1ec1ccd4","5645":"0a2b4427","7569":"ebe2b45a"}[chunkId] + ".chunk.css";
};